import React from "react";

const styles = {
    made_in_india: "bg-saffron-50 text-saffron-700 border-saffron-200",
    free_plan: "bg-indiagreen-50 text-indiagreen-700 border-indiagreen-200",
    open_source: "bg-purple-50 text-purple-700 border-purple-200",
    accepts_inr: "bg-amber-50 text-amber-800 border-amber-200",
    govt_backed: "bg-blue-50 text-blue-700 border-blue-200",
};

export function Pill({ children, kind = "made_in_india", className = "" }) {
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${styles[kind]} ${className}`}
        >
            {children}
        </span>
    );
}

export function ProductBadges({ product, testIdPrefix = "" }) {
    return (
        <div className="flex flex-wrap items-center gap-1.5">
            {product.is_made_in_india && (
                <Pill
                    kind="made_in_india"
                    className=""
                    data-testid={`${testIdPrefix}badge-india`}
                >
                    <span aria-hidden>🇮🇳</span> Verified Indian
                </Pill>
            )}
            {product.is_govt_backed && (
                <Pill kind="govt_backed">
                    <span aria-hidden>🏛️</span> Govt Backed
                </Pill>
            )}
            {product.is_free_plan && (
                <Pill kind="free_plan">
                    <span aria-hidden>🆓</span> Free Plan
                </Pill>
            )}
            {product.is_open_source && (
                <Pill kind="open_source">
                    <span aria-hidden>📖</span> Open Source
                </Pill>
            )}
            {product.accepts_inr && (
                <Pill kind="accepts_inr">
                    <span aria-hidden>₹</span> Accepts INR
                </Pill>
            )}
        </div>
    );
}
